import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AGENT_PLATFORM_FEATURE } from '../constants/agentPlatform';
import { licenseService } from '../services/licenseService';

export function useAgentPlatformAccess() {
  const { user } = useAuth();
  const [featureCodes, setFeatureCodes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const isAdmin = user?.isAdmin === true;

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const cached = licenseService.getCachedLicense();
      if (cached?.featureCodes) {
        if (!cancelled) {
          setFeatureCodes(cached.featureCodes);
          setLoading(false);
        }
        return;
      }

      const license = await licenseService.refreshCachedLicense();
      if (!cancelled) {
        setFeatureCodes(license?.featureCodes ?? []);
        setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const access = useMemo(() => {
    const has = (code: string) => isAdmin || featureCodes.includes(code);

    return {
      hasPlatform: has(AGENT_PLATFORM_FEATURE.platform),
      hasAgents: has(AGENT_PLATFORM_FEATURE.agents),
      hasTools: has(AGENT_PLATFORM_FEATURE.tools),
      hasFlows: has(AGENT_PLATFORM_FEATURE.flows),
    };
  }, [featureCodes, isAdmin]);

  return { ...access, isAdmin, loading, featureCodes };
}
